import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { reelsSettings } from 'settings/custom/reels'
import { delays } from 'settings/custom/sounds'
import { isNewBigWin } from 'settings/custom/win'

export default class SignalMediator {
  constructor() {
    this.type = null
    this.spinModel = null
    this.winModel = null
    this.symbols = null
    this.volumeIdx = 2
    this.ui = false

    this.createSignal()
  }

  createSignal() {
    const self = this
    this.uiActive.call(this)

    signal.on('ACTION:LOAD', self.init.bind(this))

    signal.once('SOUND:load', function () {
      signal.once('REELS-START', function () {
        signal.dispatch('SOUND:reels-spin:first')
      })
    })

    signal.on('REELS-START', function (value) {
      self.type = game.models.ModeModel.turbo
      self.volumeIdx = 2

      if (value !== 'explosion') {
        signal.dispatch(`SOUND:reels-spin:${self.type}`)
      }
    })

    signal.on('SCATTER:START', function () {
      signal.dispatch('SOUND:SCATTER-BEGIN', self.volumeIdx++)
      self.type = 'scatter'
    })

    signal.on('BEGIN-STOP-REEL', function regular(id) {
      gsap.delayedCall(delays[self.type], self.stop.bind(self), [id])
    })

    signal.on('WIN-COLLECT', function ({ type }) {
      const isWild = self.winModel.winLines.some((line) => {
        return line.path.some((pos) =>
          self.spinModel.matrix[pos[0]][pos[1]] === '2',
        )
      })

      if (type === 'regular' && isWild) {
        signal.dispatch('SOUND:win:wild')
      }

      if(isNewBigWin){
        switch (type){
          case 'big':
            signal.dispatch(`SOUND:win:${type}`)
            break
          case 'mega':
            signal.dispatch('SOUND:win:big')
            break
          case 'ultra':
            signal.dispatch('SOUND:win:big')
            break

          case 'regular':
            if (self.checkRegularSound()) {
              signal.dispatch(`SOUND:win:${type}`)
            }
            break
        }

      }
      else {
        if (self.checkRegularSound()) {
          signal.dispatch(`SOUND:win:${type}`)
        }
      }

    })

  }

  checkRegularSound() {
    return game.models.BetModel.getValue() < game.models.WinModel.get().linesWin
  }

  init() {
    this.spinModel = game.models.SpinModel.get()
    this.winModel = game.models.WinModel.get()
    this.symbols = game.models.SpinModel.get().reelSymbols
  }

  stop(id) {
    this.checkReelStop(id)
    this.checkWildOrScatterStop(id)
  }

  checkWildOrScatterStop(id) {
    this.spinModel.matrix[id].forEach((symbol) => {
      if (symbol === '1') {
        signal.dispatch('SOUND:SYMBOL-STOP', 1)
      }
      if (symbol === '2') {
        signal.dispatch('SOUND:SYMBOL-STOP', 2)
      }
    })
  }

  checkReelStop(id) {
    const isFs = game.models.FreespinModel.get().left
    if (isFs && reelsSettings.soundFsReelStop) {
      signal.dispatch('SOUND:REEL-FS-STOP', id)
    }
    else {
      signal.dispatch('SOUND:REEL-STOP', id)
    }
  }

  // best(acc, current) {
  //   return Math.min(this.symbols.indexOf(current), acc)
  // }

  uiActive(){
    signal.on('STATE:IN:BET', () => this.ui = true)
    signal.on('STATE:OUT:BET', () => this.ui = false)

    signal.on('RADIO:ui', (value) => this.ui && signal.dispatch('SOUND:ui', value))
  }
}
